module.exports = __webpack_public_path__ + "img/mitos.e4be2b1c.webp";